import React from 'react';
import ReactDOM from 'react-dom';
import { AssetList } from "./components";

export const initVdcAssetList = (target) => {
  if (target) {
    Promise.all([
      fetchJSON(target.dataset.assetsUrl),
      fetchJSON(target.dataset.notificationsUrl)
    ]).then(([data, notifications]) => {
      ReactDOM.render(
        <AssetList
          data={data}
          notifications={notifications}
          activityURL={target.dataset.activityUrl}
          onAssetSelected={onAssetSelected}
          onAssetHovered={onAssetHovered}
          envopsMode={target.dataset.envopsMode === "true"}
        />,
        target
      )
    }).catch((error) => {
      console.error(error);
      target.textContent = "Unable to load assets.";
    })

    function onAssetSelected(newSelection, oldSelection) {
      if (oldSelection) {
        if (Array.isArray(oldSelection)) {
          oldSelection.forEach((old) => { onAssetSelected(null, old) })
        } else {
          const event = new CustomEvent("vdcAssetList:assetUnselected", {
            bubbles: true,
            detail: {
              asset: oldSelection,
            }
          })
          target.dispatchEvent(event)
        }
      }
      if (newSelection) {
        if (Array.isArray(newSelection)) {
          newSelection.forEach((ns) => { onAssetSelected(ns, null) })
        } else {
          const event = new CustomEvent("vdcAssetList:assetSelected", {
            bubbles: true,
            detail: {
              asset: newSelection,
            }
          })
          target.dispatchEvent(event)
        }
      }
    }

    function onAssetHovered(newHover, oldHover) {
      if (oldHover) {
        const event = new CustomEvent("vdcAssetList:assetUnhovered", {
          bubbles: true,
          detail: {
            asset: oldHover,
          }
        })
        target.dispatchEvent(event)
      }
      if (newHover) {
        const event = new CustomEvent("vdcAssetList:assetHovered", {
          bubbles: true,
          detail: {
            asset: newHover,
          }
        })
        target.dispatchEvent(event)
      }
    }
  }
};

function fetchJSON(url) {
  window.vdcDataRequests = window.vdcDataRequests || {};
  if (window.vdcDataRequests[url] == null) {
    window.vdcDataRequests[url] = fetch(url, {
      credentials: "include",
      headers: {
        "Accept": "application/json",
      },
    }).then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to load ${url}: ${response.status} ${response.statusText}`);
      }
      return response.json();
    });
  }
  return window.vdcDataRequests[url];
}
